var $ = require('jquery');

export class CustomSelect {
  private $el;
  private $wrapper;
  private $customSelect;
  private $value;
  private block;


  constructor(private element: HTMLElement, private selectClass) {
    this.block = selectClass;
    this.$el = $(element);
  }

  private _createElements() {
    // Create html
    this.$wrapper = $('<div class="' + this.block + '__wrapper"></div>');
    this.$customSelect = $('<div class="' + this.block + '__custom-select"></div>');
    this.$value = $('<span class="' + this.block + '__select-value"></span>');
    this.$el.addClass(this.block + '__select');

    this.$value.appendTo(this.$customSelect);
    this.$customSelect.appendTo(this.$wrapper);
    this.$wrapper.insertBefore(this.$el);
    this.$el.appendTo(this.$wrapper);
  }

  private _selectIndexByValue(value) {
    var select = this.$el[0],
        i, l;

    for (i = 0, l = select.options.length; i < l; i++) {
      if(select.options[i].value === value) {
        select.options.selectedIndex = i;
      }
    }

    return 0;
  }

  private _updateText() {
    var select = this.$el[0];

    if(select.selectedIndex !== -1) {
      this.$value.text(select.options[select.selectedIndex].text);
    }
  }

  private _attachListeners()  {
    var self = this,
        firstChange = true;

    this.$el.on('change', function () {
      var $this = $(this),
          value = $this.val();

      // If there is no initial value and we have data-value available, this is dynamically updated select that has been submitted, so let's try to select that as default value
      if (!value && $this.data('value') && firstChange) {
        self._selectIndexByValue($this.data('value'));
        firstChange = false;
      }
      self._updateText();
    });
  }

  public init() {
    if(!this.$el.length) {
      return;
    }

    this._createElements();
    this._attachListeners();

    // Init selected value
    this._updateText();
  }
}
